import { useLayoutEffect, useRef } from 'react';
import { ID } from '@/utils/enums';

const useAppRefs = () => {
  const headerRef = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const dialogContentRef = useRef<HTMLDivElement | null>(null);
  const quizHeadRef = useRef<HTMLDivElement | null>(null);
  const quizRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const header = document.getElementById(ID.APP_HEADER);
    const content = document.getElementById(ID.APP_WRAPPER);
    const dialogContent = document.getElementById(ID.DIALOG_CONTENT);
    const quizHead = document.getElementById(ID.QUIZ_HEADER);
    const quiz = document.getElementById(ID.QUIZ);
    if (header) headerRef.current = header as HTMLDivElement;
    if (content) contentRef.current = content as HTMLDivElement;
    if (dialogContent) dialogContentRef.current = dialogContent as HTMLDivElement;
    if (quizHead) quizHeadRef.current = quizHead as HTMLDivElement;
    if (quiz) quizRef.current = quiz as HTMLDivElement;
  }, []);

  return { headerRef, contentRef, dialogContentRef, quizHeadRef, quizRef };
};

export default useAppRefs;
